export default "__VITE_ASSET__1d21d2b7__"